import React from 'react'
import { MdOutlineClose } from 'react-icons/md'
import moment from 'moment'

const ViewHistory = ({ isOpen, data, heading, onClose }) => {
    if (!isOpen || !data) return null

    const formatDate = (timestamp) => moment(timestamp).format('DD MMM YYYY, hh:mm A')

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
            <div className='w-11/12 lg:w-full max-w-xl md:max-h-[70vh] max-h-full p-6 bg-white rounded-lg shadow-lg overflow-y-auto'>
                {/* Header */}
                <div className='flex justify-between items-center border-b pb-3 mb-4'>
                    <h2 className='text-lg font-bold text-gray-800'>{heading}</h2>
                    <div
                        onClick={onClose}
                        className='h-7 w-7 rounded-full bg-[#15A14A26] text-[#15A14A] flex items-center justify-center cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-300'
                    >
                        <MdOutlineClose size={20} title='Close' />
                    </div>
                </div>

                {/* Body */}
                <div className='space-y-3 text-sm text-gray-700'>
                    {data?.userId?.name && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>User:</span>
                            <span>{data.userId.name}</span>
                        </div>
                    )}

                    {data?.userId?.email && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Email:</span>
                            <span>{data.userId.email}</span>
                        </div>
                    )}

                    {(data.orderId || data.nmiOrderId || data._id) && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Transaction ID:</span>
                            <span className='break-all text-right'>{data.orderId || data.nmiOrderId || data._id}</span>
                        </div>
                    )}

                    {data.createdAt && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Request Date & Time:</span>
                            <span>{formatDate(data.createdAt)}</span>
                        </div>
                    )}

                    <div className='flex justify-between'>
                        <span className='font-medium'>Transaction Type:</span>
                        <span className='uppercase'>{data.expressType ? (data.expressType === 'express-merchant' ? 'Express Merchant' : data.expressType) : (heading === 'Swap History' ? 'SWAP' : 'EXPRESS')}</span>
                    </div>

                    <div className='flex justify-between'>
                        <span className='font-medium'>Country:</span>
                        <span>{data.country || data.userId?.country || data.txMetaData?.country || 'N/A'}</span>
                    </div>

                    {(data?.toCoinId || data?.coinId) && (
                        <div className='flex justify-between items-center'>
                            <span className='font-medium'>Coin:</span>
                            <div className='flex items-center gap-2'>
                                <img
                                    src={data?.toCoinId?.logo || data?.coinId?.logo}
                                    alt='coin'
                                    className='h-5 w-5'
                                />
                                <span>
                                    {(data?.toCoinId?.name || data?.coinId?.name)} (
                                    {data?.toCoinId?.symbol || data?.coinId?.symbol})
                                </span>
                            </div>
                        </div>
                    )}

                    {data.fiatCurrency && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Fiat Currency:</span>
                            <span className='uppercase'>{data.fiatCurrency}</span>
                        </div>
                    )}

                    {data.fiatAmount && (data.expressAmount || data.amount) ? (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Exchange Rate:</span>
                            <span>1 {data?.toCoinId?.symbol || data?.coinId?.symbol || 'PKRD'} ≈ {(Number(data.fiatAmount) / Number(data.expressAmount || data.amount || 1)).toFixed(2)} {data.fiatCurrency?.toUpperCase() || ''}</span>
                        </div>
                    ) : null}

                    {data.amount !== undefined && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Requested Amount:</span>
                            <span>{data.amount}</span>
                        </div>
                    )}

                    {data.swapAmount !== undefined && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Swap Amount:</span>
                            <span>{data.swapAmount}</span>
                        </div>
                    )}

                    {data.expressAmount && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>PKRD Amount:</span>
                            <span>{data.expressAmount}</span>
                        </div>
                    )}

                    {(data.networkFee !== undefined || data.knowledgeFee !== undefined || data.innovationFee !== undefined) && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Processing Fee:</span>
                            <span>{(Number(data.networkFee || 0) + Number(data.knowledgeFee || 0) + Number(data.innovationFee || 0)).toFixed(4)}</span>
                        </div>
                    )}

                    {data.fiatAmount && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Total Amount:</span>
                            <span>{data.fiatAmount} {data.fiatCurrency?.toUpperCase() || ''}</span>
                        </div>
                    )}

                    <div className='flex justify-between'>
                        <span className='font-medium'>Payment Method:</span>
                        <span>{data.paymentMethod || data.txMetaData?.paymentMethod || 'Credit / Debit Card'}</span>
                    </div>

                    {data.status && (
                        <div className='flex justify-between'>
                            <span className='font-medium'>Current Status:</span>
                            <span className='capitalize'>{data.status}</span>
                        </div>
                    )}

                    <div className='flex justify-between'>
                        <span className='font-medium'>Admin Remarks:</span>
                        <span className='break-all text-right'>{data.failureReason || data.adminRemarks || data.remarks || 'N/A'}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewHistory
